export const ACTIVITY_FEED = {
  BUTTON: 'activity-feed-button',
  DIALOG: 'activity-feed-dialog',
  TABS: 'activity-feed-tabs',
  COMMENTS_TAB: 'activity-feed-comments-tab',
  MANNY_CHATS_TAB: 'activity-feed-manny-chats-tab',
  MARK_ALL_READ_BTN: 'activity-feed-mark-all-read-btn',
  NEW_COMMENTS_COUNT: 'activity-feed-new-comments-count',
  MANNY_CHATS_LIST: 'activity-feed-manny-chats-list',
  MANNY_CHATS_EMPTY: 'activity-feed-manny-chats-empty',
  MANNY_CHATS_ERROR: 'activity-feed-manny-chats-error',
  MANNY_FEED_ITEM: 'activity-feed-manny-feed-item'
} as const;
